module.exports = __webpack_public_path__ + "src/images/measurements/neckCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/neckCircumference.jpg
// module id = 1153
// module chunks = 0